<app-waiting *ngIf="!resultsLoaded"></app-waiting>
<div class="flex-container new-traveler-form" *ngIf="resultsLoaded">
  <div class="container">
    <section class="new-traveler-form-cont">
      <div class="twoColLayout main-content">
        <div class="registerForm-title-section col">
          <h2 class="title">{{content?.['b2b.managetraveler.efcompleteprofile']}}</h2>
        </div>

        <form class="form-new">
          <!-- Corporate Information -->
          <div class="f-col">
            <div class="f-row filled-action-row">
              <h6 class="title-subText m-bottom-8x">
                {{content?.['b2b.managetraveler.personalinfo']}}
              </h6>
            </div>

            <form class="form-info-section" [formGroup]="dependentForm">
              <div class="f-row">
                <div class="f-col">
                  <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                    [searchFn]="_CommonService.customCountrySearchFn" formControlName="Nationality" bindValue="isoCode"
                    [placeholder]="content?.['b2b.managetraveler.nationality']"
                    (contextmenu)="_CommonService.disableRightClick($event)"
                    (paste)="_CommonService.onPasteBlocked($event)"
                    (keypress)="_CommonService.blockInvalidCharacters1($event)">
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{ item.group }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span class="ng-option-label">
                        <ng-container *ngIf="!!item?.newFlag?.src">
                          <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                            class="flag-img" [height]="item.height" [width]="item.width" />
                        </ng-container>
                        {{ item?.countryName }}
                      </span>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span class="ng-value-label">
                        {{ item.nationality }}
                      </span>
                    </ng-template>
                    <ng-template ng-notfound-tmp>
                      <div class="no-items-found">
                        <img src="../../../../../assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'"
                          class="no-items-image" />
                        <p>
                          {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                  <mat-error class="px-4"
                    *ngIf="dependentForm.get('Nationality')?.hasError('required') && dependentForm.get('Nationality')?.touched">
                    {{content?.dictionary?.['b2b.managetraveler.selectnationality']}}</mat-error>
                </div>
              </div>

              <div class="f-row">
                <div class="f-col">
                  <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                    [searchFn]="_CommonService.customCountrySearchFn" formControlName="residence" bindValue="isoCode"
                    [placeholder]="content?.['b2b.managetraveler.placeofresidence']"
                    (contextmenu)="_CommonService.disableRightClick($event)"
                    (paste)="_CommonService.onPasteBlocked($event)"
                    (keypress)="_CommonService.blockInvalidCharacters1($event)">
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{ item.group }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span class="ng-option-label">
                        <ng-container *ngIf="!!item?.newFlag?.src">
                          <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                            class="flag-img" [height]="item.height" [width]="item.width" />
                        </ng-container>
                        {{ item?.countryName }}
                      </span>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span class="ng-value-label">
                        {{ item.countryName }}
                      </span>
                    </ng-template>
                    <ng-template ng-notfound-tmp>
                      <div class="no-items-found">
                        <img src="../../../../../assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'"
                          class="no-items-image" />
                        <p>
                          {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>
                  <mat-error class="px-4"
                    *ngIf="dependentForm.get('residence')?.hasError('required') && dependentForm.get('residence')?.touched">
                    {{content?.dictionary?.['b2b.register.selectpor']}}</mat-error>
                </div>
              </div>

              <div class="f-row">
                <div class="f-col">
                  <mat-form-field>
                    <mat-label>{{
                      this.CommonObj.docName || "National ID/IQAMA/Passport"
                      }}</mat-label>
                    <input matInput formControlName="identityNumber" (blur)="trimField('identityNumber'); this.CommonObj.docType === 'passport' ? validatePassportNumber() : ''"
                      (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)" (keypress)="blockInvalidCharacters1($event);this.CommonObj.docName != 'Passport'?verifyELM('nn'):''
                      " />
                    <mat-error
                      *ngIf="dependentForm.get('identityNumber')?.hasError('required') && dependentForm.get('identityNumber')?.touched">
                      <ng-container *ngIf="CommonObj.docType === 'passport'">
                        {{ content?.dictionary?.['b2b.register.enterpassport'] || 'Please enter Passport no.' }}
                      </ng-container>
                      <ng-container *ngIf="CommonObj.docType !== 'passport'">
                        Please enter&nbsp;{{ this.CommonObj.docName }} {{this.CommonObj.docName == 'National ID'?'':'
                        no.'}}
                      </ng-container>
                    </mat-error>
                    <!--   for duplicate cmp name check-->
                    <mat-error *ngIf="
                          dependentForm.get('identityNumber')?.hasError('pattern') &&
                          dependentForm.get('identityNumber')?.touched &&
                          CommonObj.docType === 'passport'
                        ">
                      {{ content?.dictionary?.['b2b.managetraveler.passportformat'] ||
                      'Passport must be 6–12 alphanumeric characters.' }}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm
                            .get('identityNumber')
                            ?.hasError('minlength') &&
                          dependentForm.get('identityNumber')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.idchar']}}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm
                            .get('identityNumber')
                            ?.hasError('maxlength') &&
                          dependentForm.get('identityNumber')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.cannotexceedid']}}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm
                            .get('identityNumber')
                            ?.hasError('elmError')
                        ">
                      {{content?.dictionary?.['b2b.register.InvalidIdNumber']}}</mat-error>
                    <mat-error *ngIf="dependentForm.get('identityNumber')?.hasError('invalidPassportNumber')">
                      Invalid {{ this.CommonObj.docName }} for the selected country.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- If user filled Passport number -->

              <div class="f-col position-relative" *ngIf="
                    dependentForm.get('residence')?.value &&
                    dependentForm.get('Nationality')?.value
                  ">
                <mat-form-field appearance="fill" (click)="
                      showComponent('isExpiaryCalendarVisible', 'docExpiary');
                      $event.stopPropagation()
                    " (contextmenu)="_CommonService.disableRightClick($event)"
                  (paste)="_CommonService.onPasteBlocked($event)"
                  (keypress)="_CommonService.blockInvalidCharacters1($event)">
                  <mat-label>{{ this.CommonObj.docName + " " }}
                    {{content?.['b2b.managetraveler.expirydate']}}</mat-label>
                  <input matInput formControlName="docExpiary" (blur)="verifyELM('nn')" [value]="
                        selectedExpiryDate
                          ? (selectedExpiryDate | date : 'dd/MM/y')
                          : ''
                      " [required]="this.CommonObj.docName" readonly />
                  <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                  <mat-error *ngIf="
                        dependentForm.get('docExpiary')?.hasError('required') &&
                        dependentForm.get('docExpiary')?.touched
                      ">
                    {{ this.CommonObj.docName }} expiry date is required.
                  </mat-error>
                </mat-form-field>
                <app-expiry-date *ngIf="isChildVisible['isExpiaryCalendarVisible']" [passengerTravelerCode]="'ADT'"
                  (dateSelected)="
                      onDateSelected2($event, 'isExpiaryCalendarVisible')
                    " (confirm)="onConfirm('isExpiaryCalendarVisible')" [filledDate]="
                      selectedExpiryDate
                        ? (selectedExpiryDate | date : 'dd/MM/y')
                        : ''
                    " [maxYearLimit]="docExpiryMaxYears" [useCurrentDateAsMin]="true">
                </app-expiry-date>
              </div>

              <div class="f-row" *ngIf="this.CommonObj.docName == 'Passport'">
                <div class="f-col">
                  <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                    [searchFn]="_CommonService.customCountrySearchFn" formControlName="issueCountry" bindValue="isoCode"
                    [placeholder]="content?.['b2b.managetraveler.issuingcountry']"
                    (contextmenu)="_CommonService.disableRightClick($event)"
                    (paste)="_CommonService.onPasteBlocked($event)"
                    (keypress)="_CommonService.blockInvalidCharacters1($event)"
                    [required]="this.CommonObj.docName == 'Passport'">
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{ item.group }}
                    </ng-template>
                    <mat-error *ngIf="dependentForm.get('issueCountry').hasError('required')">
                      Document issueing country required.
                    </mat-error>
                    <ng-template ng-option-tmp let-item="item">
                      <span class="ng-option-label">
                        <ng-container *ngIf="!!item?.newFlag?.src">
                          <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                            class="flag-img" [height]="item.height" [width]="item.width" />
                        </ng-container>
                        {{ item?.countryName }}
                      </span>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span class="ng-value-label">
                        {{ item.nationality }}
                      </span>
                    </ng-template>
                    <ng-template ng-notfound-tmp>
                      <div class="no-items-found">
                        <img src="../../../../../assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'"
                          class="no-items-image" />
                        <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                      </div>
                    </ng-template>
                  </ng-select>
                  <mat-error class="px-4"
                    *ngIf="dependentForm.get('issueCountry')?.hasError('required') && dependentForm.get('issueCountry')?.touched">
                    {{ content?.['phrases.b2b.managetraveler.countryofissuereq'] }}</mat-error>
                </div>
              </div>
              <div class="f-col hideCalendar position-relative">
                <mat-form-field (click)="
                      showComponent('isDOBCalendarVisible', 'dateOfBirth');
                      $event.stopPropagation()
                    " (contextmenu)="_CommonService.disableRightClick($event)"
                  (paste)="_CommonService.onPasteBlocked($event)"
                  (keypress)="_CommonService.blockInvalidCharacters1($event)">
                  <mat-label>{{content?.['b2b.managetraveler.dateofbirth']}}</mat-label>
                  <mat-icon fontSet="material-symbols-outlined" matSuffix> calendar_today </mat-icon>

                  <input matInput #dobInput formControlName="dateOfBirth" readonly (blur)="verifyELM('nn')" />

                  <mat-error *ngIf="
                        dependentForm.get('dateOfBirth')?.hasError('required') &&
                        dependentForm.get('dateOfBirth')?.touched
                      ">
                    {{content?.dictionary?.['b2b.passenger.errordateofbirth']}}
                  </mat-error>
                </mat-form-field>
                <app-date-of-birth-calendar *ngIf="isChildVisible['isDOBCalendarVisible']"
                  (dateSelected)="onDateSelected($event)" [maxDateAsToday]="true"
                  (confirm)="onConfirm('isDOBCalendarVisible')"></app-date-of-birth-calendar>
              </div>

              <div class="f-row">
                <div class="f-col">
                  <mat-form-field>
                    <mat-label>{{ manageTravelerDataContent?.['b2b.managetraveler.relationwithuser'] }}</mat-label>
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">
                      stat_minus_1
                    </mat-icon>
                    <mat-select disableRipple formControlName="relationship">
                      <mat-option *ngFor="let relation of relationshipList" [value]="relation">{{ relation
                        }}</mat-option>
                    </mat-select>
                    <mat-error>
                      Relationship is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="f-row two--ColLayout passenger-title-input">
                <div class="f-col control-wrapper">
                  <mat-form-field>
                    <mat-label>{{content?.['b2b.managetraveler.title']}}</mat-label>
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">
                      stat_minus_1
                    </mat-icon>
                    <mat-select disableRipple formControlName="title"
                      (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)" (keypress)="
                          _CommonService.blockInvalidCharacters1($event)
                        ">
                      <mat-option [value]="title.Phrase" *ngFor="
                            let title of filteredTitles
                          ">{{ title.Phrase }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="
                          dependentForm.get('title')?.hasError('required') &&
                          dependentForm.get('title')?.touched
                        ">
                      {{content?.dictionary?.['b2b.managetraveler.selectatitle']}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="f-col control-wrapper">
                  <mat-form-field>
                    <mat-label>{{content?.['b2b.managetraveler.firstname']}}</mat-label>
                    <input matInput formControlName="firstname" (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)" (keypress)="
                          _CommonService.allowAlphabetsOnly($event)
                        " (blur)="trimField('firstname')" />
                    <mat-error *ngIf="
                          dependentForm.get('firstname')?.hasError('required') &&
                          dependentForm.get('firstname')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.enterfirstname']}}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('firstname')?.hasError('maxlength')
                        ">
                      {{content?.dictionary?.['b2b.register.cannotexceedfirstname']}}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('firstname')?.hasError('minlength')
                        ">
                      {{content?.dictionary?.['b2b.register.firstname2char']}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="f-row two--ColLayout">
                <div class="f-col">
                  <mat-form-field>
                    <mat-label>{{content?.['b2b.managetraveler.middlename']}}</mat-label>
                    <input matInput formControlName="middleName"
                      (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)" (keypress)="
                          _CommonService.allowAlphabetsOnly($event)
                        " (blur)="trimField('middleName')" />
                  </mat-form-field>
                </div>
                <div class="f-col">
                  <mat-form-field>
                    <mat-label>{{content?.['b2b.managetraveler.lastname']}}</mat-label>
                    <input matInput formControlName="lastname" (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)" (keypress)="
                          _CommonService.allowAlphabetsOnly($event)
                        " (blur)="trimField('lastname')" />
                    <mat-error *ngIf="
                          dependentForm.get('lastname')?.hasError('required') &&
                          dependentForm.get('lastname')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.enterlastname']}}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('lastname')?.hasError('maxlength') &&
                          dependentForm.get('lastname')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.cannotexceedlastname']}}</mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('lastname')?.hasError('minlength') &&
                          dependentForm.get('lastname')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.lastname2char']}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="f-row">
                <div class="f-col">
                  <div class="f-row validation-col radio-group-container">
                    <label class="mat-label" for="Gender">{{content?.['b2b.managetraveler.gender']}}</label>
                    <mat-radio-group id="gender" aria-label="Select a gender" formControlName="gender">
                      <mat-radio-button value="Male">{{content?.['b2b.managetraveler.male']}}</mat-radio-button>
                      <mat-radio-button value="{{ manageTravelerDataContent?.['b2b.managetraveler.female'] }}">Female</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>

              <div class="f-row">
                <div class="f-col">
                  <mat-form-field>
                    <mat-label>{{content?.['b2b.managetraveler.emailaddress']}}</mat-label>
                    <input matInput formControlName="email" (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)"
                      (keypress)="_CommonService.blockInvalidCharactersForEmail($event)" />
                    <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
                    <mat-error *ngIf="dependentForm.get('email')?.hasError('existEmail')">
                      {{content?.dictionary?.['b2b.register.emailexists']}}
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('email')?.hasError('required') &&
                          dependentForm.get('email')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.emailaddressreq']}}
                    </mat-error>
                    <mat-error *ngIf="
                      dependentForm.get('email')?.hasError('maxlength') &&
                      dependentForm.get('email')?.touched
                    ">
                      {{content?.dictionary?.['b2b.managecompany.emailcannotexceed']}}
                      
                    </mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('email')?.hasError('email') &&
                          dependentForm.get('email')?.touched
                        ">
                      {{content?.dictionary?.['b2b.register.entervalidinput']}}</mat-error>
                    <mat-error *ngIf="
                          dependentForm.get('email')?.hasError('isExist') &&
                          dependentForm.get('email')?.touched
                        ">
                      {{content?.dictionary?.['b2b.managecompany.emailalreadyexists']}}
                    </mat-error>
                    <!--   
                      <mat-error
                        *ngIf="
                          dependentForm
                            .get('email')
                            ?.hasError('domainMismatch') &&
                          dependentForm.get('email')?.touched
                        "
                        >{{ "Domain name does not match" }}</mat-error
                      >-->
                  </mat-form-field>
                </div>
              </div>

              <div class="f-row two--ColLayout">
                <div class="f-col">
                  <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                    [searchFn]="_CommonService.customCountrySearchFn" formControlName="countryCode" bindValue="code"
                    [placeholder]="content?.['b2b.managetraveler.countrycode']"
                    (contextmenu)="_CommonService.disableRightClick($event)"
                    (paste)="_CommonService.onPasteBlocked($event)"
                    (keypress)="_CommonService.blockInvalidCharacters($event)">
                    <ng-template ng-optgroup-tmp let-item="item">
                      {{ item.group }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span class="ng-option-label">
                        <ng-container *ngIf="!!item?.newFlag?.src">
                          <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}"
                            class="flag-img" [height]="item.height" [width]="item.width" />
                        </ng-container>
                        {{ item.code }} ({{ item?.countryName }})
                      </span>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span class="ng-value-label"> {{ item.code }} </span>
                    </ng-template>
                    <ng-template ng-notfound-tmp>
                      <div class="no-items-found">
                        <img src="../../../../../assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'"
                          class="no-items-image" />
                        <p>
                          {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}
                        </p>
                      </div>
                    </ng-template>
                  </ng-select>

                  <mat-error class="px-4" *ngIf="
                        dependentForm.get('countryCode')?.hasError('required') &&
                        dependentForm.get('countryCode')?.touched
                      ">
                    {{content?.dictionary?.['b2b.register.selectcountrycode']}}</mat-error>
                </div>
                <div class="f-col">
                  <mat-form-field>
                    <mat-label>{{content?.['b2b.managetraveler.mobileno']}}</mat-label>
                    <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                    <input type="text" matInput formControlName="mobileNumber"
                      (contextmenu)="_CommonService.disableRightClick($event)"
                      (paste)="_CommonService.onPasteBlocked($event)"
                      (keypress)="_CommonService.allowNumberOnly($event)" />
                    <mat-error
                      *ngIf="dependentForm.get('mobileNumber')?.hasError('required') && dependentForm.get('mobileNumber')?.touched">{{content?.dictionary?.['b2b.register.mobilereq']}}
                    </mat-error>
                    <mat-error *ngIf=" dependentForm .get('mobileNumber') ?.hasError('minlength') && dependentForm.get('mobileNumber')?.touched ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}} </mat-error>
                    <mat-error *ngIf=" dependentForm .get('mobileNumber') ?.hasError('maxlength') && dependentForm.get('mobileNumber')?.touched ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                    <!-- <mat-error *ngIf=" dependentForm .get('mobileNumber') ?.hasError('pattern') && dependentForm.get('mobileNumber')?.touched ">{{content?.dictionary?.['b2b.managetraveler.mobilenoexactdigits']}}</mat-error> -->
                  </mat-form-field>
                </div>
              </div>



              <div class="f-row">
                <div class="f-col registerForm-title-section">
                  <h2 class="title-subText title-alfursan">
                    {{content?.['b2b.managetraveler.efalfursanloyaltypro']}}
                    &nbsp;
                    <span>· {{content?.['b2b.managetraveler.optional']}}</span>
                  </h2>
                  <p class="link-section m-top-8x">
                    {{content?.['b2b.managetraveler.efaddyouralfursan']}}
                  </p>
                </div>
              </div>
              <div class="f-row">
                <mat-slide-toggle
                  formControlName="alfursanOptIn">{{content?.['b2b.managetraveler.effillinfonow']}}</mat-slide-toggle>
              </div>

              <div class="f-col" *ngIf="dependentForm.get('alfursanOptIn')?.value == true">
                <mat-form-field>
                  <mat-label>{{content?.['b2b.managetraveler.efalfursanid']}}</mat-label>
                  <input matInput formControlName="alfursanID" (contextmenu)="_CommonService.disableRightClick($event)"
                    (paste)="_CommonService.onPasteBlocked($event)"
                    (keypress)="_CommonService.blockInvalidCharactersForEmail($event)" />

                  <mat-error *ngIf="dependentForm.get('alfursanID')?.touched">

                    <!-- Number length error -->
                    <span *ngIf="dependentForm.get('alfursanID')?.hasError('invalidNumberLength')">
                      AlFursanId must be exactly 10 digits.
                    </span>

                    <!-- Email max length -->
                    <span *ngIf="dependentForm.get('alfursanID')?.hasError('emailMaxLength')">
                      {{content?.dictionary?.['b2b.managecompany.emailcannotexceed']}}
                      
                    </span>

                    <!-- Pattern error -->
                    <span *ngIf="dependentForm.get('alfursanID')?.hasError('pattern')">
                      {{content?.['b2b.managetraveler.efalfursanid']?.split('/')[0] }} 10 digit or email allowed only.
                    </span>

                  </mat-error>

                </mat-form-field>
              </div>
              <div class="f-row m-top-40">
                <mat-checkbox (change)="onTermsChange($event.checked,'Terms_of_use')" class="checkbox-wrapper"
                  formControlName="isAgreeTermsOfUse">{{content?.['b2b.managetraveler.efaccepttermscheckbox']?.replace('Terms
                  of Use.','')}}
                  <a target="_blank" rel="noopener noreferrer"
                    href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
                    of Use</a>.
                </mat-checkbox>
              </div>

              <div class="f-row m-top-8x">
                <mat-checkbox class="checkbox-wrapper" (change)="onTermsChange($event.checked,'Privacy_policy')"
                  formControlName="accessPersonalData">{{content?.['b2b.managetraveler.efprivacypolicycheckbox']?.replace('Terms
                  of Use and Privacy Policy.','')}}
                  <a target="_blank" rel="noopener noreferrer"
                    href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
                    of Use</a> and
                  <a target="_blank" rel="noopener noreferrer"
                    href="https://www.saudia.com/en-IN/information/terms-and-conditions/privacy-policy">Privacy
                    Policy</a>.
                </mat-checkbox>
              </div>

              <div class="f-row m-top-8x">
                <mat-checkbox class="checkbox-wrapper" (change)="onTermsChange($event.checked,'Receive_offers')"
                  formControlName="accessOffersMarketingInfo">I would like to receive offers and services provided by
                  partners.
                </mat-checkbox>
              </div>
              <div class="f-row justify-end m-top-8x btn-group">
                <button mat-button class="button--secondary-small" type="button" (click)="onCancel()">
                  {{content?.['b2b.managetraveler.cancel']}}
                </button>
                <button class="button--primary-small" mat-button (click)="onSubmit(dependentForm.value)"
                  [class.disabled]="isSubmitDisabled || isLoadingSpinner">
                  {{content?.['b2b.managetraveler.save']}}
                  <mat-spinner diameter="20" class="button" *ngIf="isLoadingSpinner"></mat-spinner>
                </button>
              </div>
              <div>

              </div>
            </form>
          </div>
        </form>
      </div>
    </section>
  </div>
</div>